
export const getDeviceType = () => {
  const userAgent = navigator.userAgent;
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i;
  if (mobileRegex.exec(userAgent)) {
    return 'Mobile';
  } else {
    return 'Desktop';
  }
};

function getUTMParameters(url) {
  const queryString = url.split("?")[1];
  if (!queryString) {
    return {};
  }
  const queryParams = queryString.split("&");
  let utmParameters = {};
  for (const queryParam of queryParams) {
    const pair = queryParam.split("=");
    if (pair[0].startsWith("utm_")) {
      utmParameters[pair[0]] = pair[1];
    }
  }

  return utmParameters;
}

function getVisitedFlag() {
  return localStorage.getItem("visited");
}

function setVisitedFlag() {
  localStorage.setItem("visited", "true");
}

export const isNewVisitor = () => {
  if (getVisitedFlag() === "true") return false;
  else {
    setVisitedFlag();
    return true;
  }
};

export const sendGainsightEvent = (event, data = {}) => {
  try {
    if (window.aptrinsic) {
      window.aptrinsic("track", event, data);
    }
  } catch (e) {
    console.error("Aptrinsic tracking call failed", e);
  }
};

export const handleGainSightEventForPageVisit = (data) => {
  const { utm_source, utm_medium, utm_campaign } = getUTMParameters(
    data.pageUrl
  );
  const eventData = {
    pageBaseUrl: data.pageBaseUrl,
    deviceType: getDeviceType(),
    utm_source: utm_source === undefined ? "" : utm_source,
    utm_medium: utm_medium === undefined ? "" : utm_medium,
    utm_campaign: utm_campaign === undefined ? "" : utm_campaign,
    newUser: isNewVisitor(),
    kbType: data.kbType,
    category_slug: data.category_slug,
    article_slug: data.article_slug,
  };
  sendGainsightEvent(KB_WEBSITE_GAINSIGHT_EVENTS.PAGE_VISIT, eventData);
};

export const handleGainSightEventForPageNotFound = (originalUrl) => {
  const pageNotFoundData = {
    originalUrl,
  };
  sendGainsightEvent(
    KB_WEBSITE_GAINSIGHT_EVENTS.PAGE_NOT_FOUND,
    pageNotFoundData
  );
};

export const handleGainSightEventForSearchResults = (data) => {
  const eventData = {
    search_query: data.search_query,
    results_count: data.results_count,
    top_result_id: data.top_result_id || "",
    top_3_result_slugs: data.top_3_result_slugs || [],
    search_latency_ms: data.search_latency_ms,
  };
  sendGainsightEvent(KB_WEBSITE_GAINSIGHT_EVENTS.KB_SEARCH_RESULTS_SHOWN, eventData);
};

export const handleScrollMilestoneEvent = (articleSlug, timeToMilestoneSeconds, milestone = null) => {
  const eventData = {
    article_slug: articleSlug,
    milestone: milestone,
    time_to_milestone_seconds: timeToMilestoneSeconds,
  };
  const event = milestone ? KB_WEBSITE_GAINSIGHT_EVENTS.KB_SCROLL_MILESTONE_REACHED : KB_WEBSITE_GAINSIGHT_EVENTS.KB_ARTICLE_COMPLETED;
  sendGainsightEvent(event, eventData);
};

export const handleEngagementHeartbeatEvent = (articleSlug, cumulativeEngagedSeconds, heartbeatNumber) => {
  const eventData = {
    article_slug: articleSlug,
    cumulative_engaged_seconds: cumulativeEngagedSeconds,
    heartbeat_number: heartbeatNumber,
  };
  sendGainsightEvent(KB_WEBSITE_GAINSIGHT_EVENTS.KB_ENGAGEMENT_HEARTBEAT, eventData);
};

export const KB_WEBSITE_GAINSIGHT_EVENTS = {
  PAGE_NOT_FOUND: "pageNotFoundTriggered",
  PAGE_VISIT: "pageVisit",
  KB_SEARCH_RESULTS_SHOWN: "kb_search_results_shown",
  KB_SEARCH_ZERO_RESULTS: "kb_search_zero_results",
  KB_CATEGORY_VIEWED: "kb_category_viewed",
  KB_SEARCH_RESULT_CLICKED: "kb_search_result_clicked",
  KB_SEARCH_INITIATED: "kb_search_initiated",
  KB_SCROLL_MILESTONE_REACHED: "kb_scroll_milestone_reached",
  KB_ARTICLE_COMPLETED: "kb_article_completed",
  KB_ENGAGEMENT_HEARTBEAT: "kb_engagement_heartbeat",
  KB_SEARCH_SUBMITTED: "kb_search_submitted",
  BREADCRUMB_CLICKED: "BreadcrumbClicked",
  CATEGORY_PAGE_VIEWED: "CategoryPageViewed",
};
